<template>
  <div class="page">
    <el-table stripe :data="tableData" border
              style="width: 100%" height="100%" size="mini" @sort-change="sortChange">
      <el-table-column type="index"
                       :width="pagination.endIndex >= 1000 ? 80:50" align="center"
                       :index="pagination.beginIndex"
      ></el-table-column>
      <el-table-column prop="type" label="类别" align="center" min-width="110" show-overflow-tooltip sortable="type">
        <template slot-scope="scope">
          <span v-if="scope.row.type">{{ scope.row.type.title }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="productType" label="产品类型" align="center" min-width="110" show-overflow-tooltip sortable="productType">
        <template slot-scope="scope">
          <span v-if="scope.row.productType">{{ scope.row.productType.title }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="code" label="错误代码" align="center" min-width="110" show-overflow-tooltip sortable="code">
        <template slot-scope="scope">
          <span v-if="scope.row.code">{{ scope.row.code }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="title" label="中文名称" align="center" min-width="110" show-overflow-tooltip sortable="title">
        <template slot-scope="scope">
          <span v-if="scope.row.title">{{ scope.row.title }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="enTitle" label="英文名称" align="center" min-width="110" show-overflow-tooltip sortable="enTitle">
        <template slot-scope="scope">
          <span v-if="scope.row.enTitle">{{ scope.row.enTitle }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="notes" label="应用说明" align="center" min-width="110" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.notes">{{ scope.row.notes }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column class-name="operation" label="操作" align="center" width="90">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="修改" placement="top" :open-delay="300">
            <i @click="edit($event, scope.row)" class="el-icon-edit"></i>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除" placement="top" :open-delay="300">
            <i @click="del($event, scope.row)" class="el-icon-delete"></i>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <pagination
        :pagination="pagination"
        @currentChange="currentChange"
        @sizeChange="sizeChange"
        @refreshBtn="search"
    ></pagination>
    <myDialog ref="editDialog" :title="dialogTitle"  @submitData="submitData" @dialogClose="dialogClose" width="450px">
      <template slot="content">
        <el-form ref="form" :model="form" :rules="formRules" label-width="80px">
          <el-form-item label="类别" size="small" prop="type">
            <el-select v-model="form.type" placeholder="选择类别" filterable clearable>
              <el-option v-for="(item, index) in errorCodeTypeList"
                :key="index" :value="item.code" :label="item.title"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品类型" size="small" prop="productType">
            <el-select v-model="form.productType" placeholder="产品类型" filterable clearable>
              <el-option v-for="(item, index) in productTypeList"
                :key="index" :value="item.code" :label="item.title"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="错误代码" size="small" prop="code">
            <el-input v-model="form.code" placeholder="错误代码" clearable></el-input>
          </el-form-item>
          <el-form-item label="中文名称" size="small" prop="title">
            <el-input v-model="form.title" placeholder="中文名称" clearable></el-input>
          </el-form-item>
          <el-form-item label="英文名称" size="small" prop="enTitle">
            <el-input v-model="form.enTitle" placeholder="英文名称" clearable></el-input>
          </el-form-item>
          <el-form-item label="应用说明" size="small" prop="notes">
            <el-input v-model="form.notes" placeholder="应用说明" clearable></el-input>
          </el-form-item>
        </el-form>
      </template>
    </myDialog>
  </div>
</template>

<script>
import pagination from "@/components/pagination.vue";
import myDialog from "@/components/myDialog.vue";
import {  
  apiErrorCodeSearch, apiProductTypeList, apiErrorCodeTypeList,
  apiErrorCodeAdd, apiErrorCodeUpdate, apiErrorCodeDelete
} from "@/api/errorCode.js";

export default {
  components: {
    pagination,
    myDialog
  },
  props: {
    searchErrorCodeForm: {
      type: Object
    }
  },
  data() {
    return {
      dialogTitle: '',
      tableData: [],
      orderBy: [],
      pagination: {
        currentPage: 1,
        pageSize: 40,
        total: 102,
        beginIndex: 1,
        endIndex: 10
      },
      errorCodeTypeList: [],
      productTypeList: [],
      //选中类别对象
      typeName:{},
      form: {},
      formRules: {
        name: [
          {required: true, message: "名称不能为空！", trigger: "blur"},
          {
            min: 2,
            max: 32,
            message: "长度在 2 到 32 个字符",
            trigger: "change"
          }
        ],
        typeCode: [
          {required: true, message: "类别不能为空！", trigger: "blur"}
        ]
      }
    };
  },
  methods: {
    async getErrorCodeTypeList() {
      const res = await apiErrorCodeTypeList();
      if (res.code == 0) {
        this.errorCodeTypeList = res.data;
      }
    },
    async getProductTypeList(){ 
      const res = await apiProductTypeList({
        
      });
      if (res.code == 0) {
        this.productTypeList = res.data;
      }
    },
    // 表格数据
    async search(remove, callback) {
      if (!(remove == "noRemove")) {
        this.tableData = [];
      }
      const res = await apiErrorCodeSearch({
        ...this.searchErrorCodeForm,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        desc: this.desc,
        orderBy: this.orderBy
      });
      // console.log(res);
      if (res.code == 0) {
        this.tableData = res.data;
        this.pagination.total = res.total;
        this.pagination.beginIndex = res.beginIndex;
        this.pagination.endIndex = res.endIndex;
        if (callback)
        this.callback();
      }
    },
    // 表格数据排序
    sortChange({prop, order}) {
      this.orderBy[0] = prop;
      if (order == "ascending") {
        this.desc = false;
      } else if (order == "descending") {
        this.desc = true;
      } else {
        this.desc = undefined;
        this.orderBy = [];
      }
      this.search();
    },
    // 页码改变
    currentChange(val) {
      this.pagination.currentPage = val;
      this.search();
    },
    // 页容量改变
    sizeChange(val) {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = val;
      this.search();
    },
    openAdd() {
      this.dialogTitle = '新增'
      this.form = {};
      this.$refs.editDialog.dialogVisible = true;
    },
    edit(e, row) {
      this.dialogTitle = '编辑'
      this.$refs.editDialog.dialogVisible = true;
      this.form = {
        id: row.id,
        code: row.code,
        type:row.type.code,
        productType:row.productType.code,
        title: row.title,
        enTitle: row.enTitle,
        notes: row.notes
      };
    },
    // 对话框提交
    submitData() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          if (this.form.id) {
            apiErrorCodeUpdate(this.form).then(res => {
              if (res.code === 0) {
                this.$refs.editDialog.dialogVisible = false
                this.currentChange(1)
                this.$message({
                  message: "修改成功",
                  type: "success",
                });
                this.search();
              }
            })
          } else {
            let res = await apiErrorCodeAdd({
              ...this.form
            });
              if (res.code === 0) {
                this.$refs.editDialog.dialogVisible = false
                this.currentChange(1)
                this.$message({
                  message: "新增成功",
                  type: "success",
                });
                this.search();
              }
            }
        } else {
          return false;
        }
      });
    },
    del(e, row) {
      const h = this.$createElement;
      this.$msgbox({
        title: `删除错误代码`,
        message: h("div", null, [
          h("span", null, `请错误代码:【`),
          h("i", { style: "color: var(--themeColor)" }, row.code),
          h("span", null, `】以便确认删除`),
        ]),
        showCancelButton: true,
        confirmButtonText: `确认`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (instance.inputValue == row.code) {
              done();
            } else {
              this.$message({
                type: "warning",
                message: `输入错误，请重新输入或取消！`,
              });
            }
          } else {
            done();
          }
        },
      }).then(async () => {        
        let res = await apiErrorCodeDelete({
          id: row.id,
        });
        if (res.code == 0) {
          this.$message({
            type: "success",
            message: "删除成功"
          });
          this.search();
        }
      });
    },
    callback() {
      this.getErrorCodeTypeList();
      this.getProductTypeList();
    },
    // 关闭对话框
    dialogClose() {
      this.$refs.form.resetFields();
      this.form = {};
    },
  }
};
</script>

<style lang="less" scoped>
.page {
  height: 100%;
  display: flex;
  flex-direction: column;

  .refreshBox {
    /deep/ .el-form-item__content {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .el-input {
        width: 92%;
      }

      .icon {
        font-size: 18px;
        cursor: pointer;
      }
    }
  }
}
</style>